import React from 'react';

//import components
import StrucutreListItemContent from './StrucutreListItemContent.js';

const StrucutreListItemSingle = ({ 
    label, 
    shortDescription, 
    recordsNumber, 
    id, 
    setStructureListHeight 
}) => {
  return (
    <li className="structure__list-item--single">
      <div className="structure__list-item--single__container">
        <StrucutreListItemContent 
            id={id} 
            label={label} 
            shortDescription={shortDescription} 
            recordsNumber={recordsNumber}
            setStructureListHeight={setStructureListHeight}
        />
      </div>
    </li>
  );
};

export default StrucutreListItemSingle;



// WEBPACK FOOTER //
// ./src/components/characteristics/StrucutreListItemSingle.js